/* global module, $, _, debugger, Tracker */
(function () {
    'use strict';

    function sendClickEvent(url) {
        $.ajax({
           cache: false,
           url: url
        });
    }

    $(document).on('click', '*[data-click-event-url]', function () {
        var url = $(this).data('clickEventUrl');
        sendClickEvent(url);
    });
})();